// Number of messages fetched at a time from Conversations SDK
export const MESSAGES_LOAD_COUNT = 20;

// The maximum number of characters allowed in message input
export const CHAR_LIMIT = 32 * 1024; // 32kB

// The height of the loading spinner box shown in the message list when fetching new messages
export const MESSAGES_SPINNER_BOX_HEIGHT = 50;

export const DEFAULT_BOT_MESSAGE_DELAY_SECONDS = 0.5;

export const DEFAULT_CONFIG_NAME = "DEFAULT CONFIG";

export const TWILIO_PROVIDER_PX_OVERRIDES = {
    "borderWidths": {
        "borderWidth0": "0",
        "borderWidth10": "1px",
        "borderWidth20": "2px",
        "borderWidth30": "4px",
        "borderWidth40": "8px"
    },
    "radii": {
        "borderRadius0": "0",
        "borderRadius10": "2px",
        "borderRadius20": "4px",
        "borderRadius30": "8px",
        "borderRadius40": "12px",
        "borderRadius50": "16px",
        "borderRadius60": "20px",
        "borderRadius70": "24px",
        "borderRadius80": "28px",
        "borderRadius90": "32px",
        "borderRadiusCircle": "50%",
        "borderRadiusPill": "100px"
    },
    "breakpoints": [
        "400px",
        "1024px",
        "1232px"
    ],
    "fontSizes": {
        "fontSize10": "10px",
        "fontSize20": "12px",
        "fontSize30": "14px",
        "fontSize40": "16px",
        "fontSize50": "18px",
        "fontSize60": "20px",
        "fontSize70": "24px",
        "fontSize80": "28px",
        "fontSize90": "32px",
        "fontSize100": "40px",
        "fontSize110": "48px",
        "fontSizeBase": "100%",
        "fontSizeDisplay10": "32px",
        "fontSizeDisplay20": "48px",
        "fontSizeDisplay30": "64px"
    },
    "lineHeights": {
        "lineHeight0": "0",
        "lineHeight05": "12px",
        "lineHeight10": "16px",
        "lineHeight20": "20px",
        "lineHeight30": "20px",
        "lineHeight40": "24px",
        "lineHeight50": "28px",
        "lineHeight60": "28px",
        "lineHeight70": "32px",
        "lineHeight80": "40px",
        "lineHeight90": "40px",
        "lineHeight100": "52px",
        "lineHeight110": "64px",
        "lineHeightDisplay10": "40px",
        "lineHeightDisplay20": "60px",
        "lineHeightDisplay30": "80px"
    },
    "widths": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "maxWidths": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "minWidths": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "heights": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "maxHeights": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "minHeights": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "sizes": {
        "size0": "0",
        "size10": "88px",
        "size20": "192px",
        "size30": "296px",
        "size40": "400px",
        "size50": "504px",
        "size60": "608px",
        "size70": "712px",
        "size80": "816px",
        "size90": "920px",
        "size100": "1024px",
        "size110": "1128px",
        "size120": "1232px",
        "sizeBase0": "0",
        "sizeBase10": "4px",
        "sizeBase20": "8px",
        "sizeBase30": "12px",
        "sizeBase40": "16px",
        "sizeBase50": "20px",
        "sizeBase60": "24px",
        "sizeBase70": "28px",
        "sizeBase80": "32px",
        "sizeBase90": "36px",
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px",
        "sizeSidebar": "240px",
        "sizeSidebarCompact": "76px",
        "sizeSquare0": "0",
        "sizeSquare10": "2px",
        "sizeSquare20": "4px",
        "sizeSquare25": "6px",
        "sizeSquare30": "8px",
        "sizeSquare40": "12px",
        "sizeSquare50": "16px",
        "sizeSquare60": "20px",
        "sizeSquare70": "24px",
        "sizeSquare80": "28px",
        "sizeSquare90": "32px",
        "sizeSquare100": "36px",
        "sizeSquare110": "40px",
        "sizeSquare120": "44px",
        "sizeSquare130": "48px",
        "sizeSquare140": "52px",
        "sizeSquare150": "56px",
        "sizeSquare160": "60px",
        "sizeSquare170": "64px",
        "sizeSquare180": "68px",
        "sizeSquare190": "72px",
        "sizeSquare200": "76px",
        "sizeTopbar": "76px"
    },
    "iconSizes": {
        "sizeIcon05": "12px",
        "sizeIcon10": "16px",
        "sizeIcon20": "20px",
        "sizeIcon30": "20px",
        "sizeIcon40": "24px",
        "sizeIcon50": "28px",
        "sizeIcon60": "28px",
        "sizeIcon70": "32px",
        "sizeIcon80": "40px",
        "sizeIcon90": "40px",
        "sizeIcon100": "52px",
        "sizeIcon110": "64px"
    },
    "space": {
        "space0": "0",
        "space10": "2px",
        "space20": "4px",
        "space30": "8px",
        "space40": "12px",
        "space50": "16px",
        "space60": "20px",
        "space70": "24px",
        "space80": "28px",
        "space90": "32px",
        "space100": "36px",
        "space110": "40px",
        "space120": "44px",
        "space130": "48px",
        "space140": "52px",
        "space150": "56px",
        "space160": "60px",
        "space170": "64px",
        "space180": "68px",
        "space190": "72px",
        "space200": "76px",
        "space210": "80px",
        "space220": "84px",
        "space230": "88px",
        "space240": "92px",
        "space250": "96px",
        "space260": "100px",
        "space270": "104px",
        "space280": "108px",
        "space290": "112px",
        "space300": "116px",
        "space310": "120px",
        "spaceNegative10": "-2px",
        "spaceNegative20": "-4px",
        "spaceNegative30": "-8px",
        "spaceNegative40": "-12px",
        "spaceNegative50": "-16px",
        "spaceNegative60": "-20px",
        "spaceNegative70": "-24px",
        "spaceNegative80": "-28px",
        "spaceNegative90": "-32px",
        "spaceNegative100": "-36px",
        "spaceNegative110": "-40px",
        "spaceNegative120": "-44px",
        "spaceNegative130": "-48px",
        "spaceNegative140": "-52px",
        "spaceNegative150": "-56px",
        "spaceNegative160": "-60px",
        "spaceNegative170": "-64px",
        "spaceNegative180": "-68px",
        "spaceNegative190": "-72px",
        "spaceNegative200": "-76px"
    },
}